module.exports = __webpack_public_path__ + "static/media/15.fb546166.jpg";